<template>
	<div class="ts-flex ts-space-x-2 ts-items-center">
		<div v-for="(filter, fIndex) in model.filters">
			<a-popover v-model="filter.visible" trigger="click" placement="bottomLeft">
				<button style="height: 2.2rem;"
					class="ts-flex ts-items-center ts-bg-blue-100 ts-text-blue-500 ts-px-3 ts-space-x-1 ts-rounded focus:ts-outline-none ts-cursor-pointer">
					<p>{{ findName(filter.col) + ': ' + formatValue(filter.value) }}</p>
					<i class="fas fa-caret-down"></i>
				</button>
				<template #content>
					<div class="ts-py-1 ts-flex ts-items-center ts-space-x-1 ts-justify-between">
						<div class="ts-flex ts-space-x-2 ts-items-center ts-flex-1">
							<p class="ts-text-sm ts-whitespace-no-wrap">{{ findName(filter.col) }} : </p>
							<select v-model="filter.operator"
								class="ts-bg-transparent ts-py-0 focus:ts-outline-none ts-w-full ts-border ts-border-gray-300 ts-rounded"
								@change="operatorChange(filter)">
								<option v-for="(f, index) in filterOption(filter.col)" :key="index" :value="f.value">{{ f.label }}
								</option>
							</select>
						</div>
						<button
							class="ts-flex ts-items-center ts-justify-center ts-text-gray-300 hover:ts-text-red-500 ts-duration-200 ts-cursor-pointer focus:ts-outline-none"
							@click.prevent="removeFilter(fIndex)">
							<svg data-prefix="fas" data-icon="circle-xmark" role="img" viewBox="0 0 512 512" aria-hidden="true"
								class="svg-inline--fa fa-circle-xmark">
								<path fill="currentColor"
									d="M256 512a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM167 167c9.4-9.4 24.6-9.4 33.9 0l55 55 55-55c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-55 55 55 55c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-55-55-55 55c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l55-55-55-55c-9.4-9.4-9.4-24.6 0-33.9z"
									class=""></path>
							</svg>
						</button>
					</div>
					<template v-if="allowTextNumberInput(filter.type, filter.operator)">
						<a-input-search v-model="filter.value" :type="filter.type" :placeholder="$t('dailyCloseout.typeValue')"
							@search="onSearch(filter)"></a-input-search>
					</template>
					<template v-if="allowDate(filter.type, filter.operator)">
						<a-date-picker v-model="filter.value" format="DD-MM-YYYY" valueFormat="YYYY-MM-DD"></a-date-picker>
						<div style="text-align: right; margin-top: 8px">
							<a-button type="primary" size="small" @click="onSearch(filter)">
								{{ $t('dailyCloseout.search') }}
							</a-button>
						</div>
					</template>
					<template v-if="allowDateRange(filter.type, filter.operator)">
						<a-range-picker v-model="filter.value" format="DD-MM-YYYY" valueFormat="YYYY-MM-DD"
							style="max-width: 300px;"></a-range-picker>
						<div style="text-align: right; margin-top: 8px">
							<a-button type="primary" size="small" @click="onSearch(filter)">
								{{ $t('dailyCloseout.search') }}
							</a-button>
						</div>
					</template>
				</template>
			</a-popover>
		</div>
		<a-popover v-model="filterPopover" trigger="click" placement="bottomLeft">
			<button
				class="ts-flex ts-items-center ts-bg-blue-100 ts-text-blue-500 ts-px-3 ts-space-x-1 ts-rounded focus:ts-outline-none"
				style="height: 2.2rem;">
				<i class="fas fa-plus"></i>
				<p>{{ $t('dailyCloseout.filter') }}</p>
			</button>
			<template #content>
				<div class="ts-p-1">
					<a-input v-model="search" :placeholder="$t('dailyCloseout.search')" class="ts-mb-2"></a-input>
					<button
						class="ts-flex ts-space-x-2 ts-py-1 ts-rounded ts-w-full focus:ts-outline-none ts-duration-200 hover:ts-bg-gray-300 hover:ts-text-red-500"
						style="min-width: 130px;">
						<div class="ts-justify-center ts-items-center ts-flex" style="width: 30px;">
							<i class="fas fa-trash"></i>
						</div>
						<p>{{ $t('dailyCloseout.clearSort') }}</p>
					</button>
					<div v-for="item in columnItems"
						class="ts-py-1 ts-rounded hover:ts-bg-gray-200 hover:ts-text-gray-700 ts-duration-200 ts-px-2 ts-cursor-pointer ts-space-x-2"
						@click.stop="onAddHandler(item)">
						<i :class="iconType(item.type)"></i>
						{{ item.label }}
					</div>
				</div>
			</template>
		</a-popover>
	</div>
</template>

<script>
import { columns } from '../config';

export default {
	props: ['value'],
	data() {
		return {
			model: {},
			search: undefined,
			filterPopover: false
		}
	},
	created() {
		this.model = this.value
	},
	computed: {
		iconType: () => type => {
			if (type == 'text') {
				return 'fas fa-font'
			}
			if (type == 'date') {
				return 'far fa-clock'
			}
			if (type == 'number') {
				return 'fas fa-dollar-sign'
			}

			return 'fas fa-circle'
		},
		findName: vm => col => {
			const find = vm.columnItems.find(el => el.col === col)
			return find.label || ''
		},
		filterOption: vm => col => {
			const findFilter = vm.columnItems.find(el => el.col === col)
			if (findFilter) {
				return findFilter.filter
			}
			return []
		},
		columnItems() {
			const search = (this.search || '').toLowerCase()
			return columns()
				.filter(el => el.filters !== undefined)
				.map(el => ({
					col: el.key || el.col,
					label: this.$t(`dailyCloseout.${el.label}`),
					type: el.type,
					filter: el.filters
				}))
				.filter(item => item.label.toLowerCase().includes(search))
		},
		allowTextNumberInput: () => (type, operator) => {
			return ['text', 'number'].includes(type) && !['is_empty', 'is_not_empty'].includes(operator)
		},
		allowDate: () => (type, operator) => {
			return (['date'].includes(type) && operator !== 'is_between') && !['is_empty', 'is_not_empty'].includes(operator)
		},
		allowDateRange: () => (type, operator) => {
			return (['date'].includes(type) && operator == 'is_between') && !['is_empty', 'is_not_empty'].includes(operator)
		}
	},
	methods: {
		onAddHandler(item) {
			this.model.filters.push(
				{
					col: item.col,
					value: undefined,
					operator: item.filter.length ? item.filter[0].value : undefined,
					type: item.type,
					visible: true
				}
			)
			this.filterPopover = false
		},
		removeFilter(index) {
			this.model.filters.splice(index, 1)
			localStorage.setItem('daily_closeout_report_filter', JSON.stringify(this.model.filters))
		},
		operatorChange(filter) {
			filter.value = undefined
		},
		onSearch(filter) {
			this.$emit('search')
			filter.visible = false
			localStorage.setItem('daily_closeout_report_filter', JSON.stringify(this.model.filters))
		},
		formatValue(value) {
			// Handle null/undefined
			if (value === null || value === undefined) return '';

			// Check for date range (array with 2 valid dates)
			if (Array.isArray(value) && value.length === 2) {
				const [start, end] = value;
				if (this.isDate(start) && this.isDate(end)) {
					return `${this.formatSingleDate(start)} - ${this.formatSingleDate(end)}`;
				}
			}

			// Check for single date
			if (this.isDate(value)) {
				return this.formatSingleDate(value);
			}

			// Handle strings (limit to 40 chars)
			if (typeof value === 'string') {
				return value.length > 40 ? `${value.substring(0, 40)}...` : value;
			}

			// Handle numbers (add thousands separators)
			if (typeof value === 'number') {
				return value.toLocaleString();
			}

			// Fallback for other types
			return String(value);
		},

		isDate(dateStr) {
			return !isNaN(Date.parse(dateStr)) &&
				typeof dateStr === 'string' &&
				dateStr.includes('-'); // Simple ISO format check
		},

		formatSingleDate(dateStr) {
			const date = new Date(dateStr);
			return date.toLocaleDateString('en-US', {
				day: 'numeric',
				month: 'short',
				year: 'numeric'
			});
		}
	}
}
</script>